"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultStaffInstructionsPreScripts = exports.DefaultStaffInstructionsPetDetails = exports.DefaultStaffInstructionsOwnerDetails = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/* eslint-disable max-len */

var DefaultStaffInstructionsPreScripts = exports.DefaultStaffInstructionsPreScripts = {
  preStart: [{
    script: function script(_ref) {
      var staffContext = _ref.staffContext;
      return "Welcome to ".concat(staffContext.brokerFriendlyName, ". You are speaking with ").concat(staffContext.staffName, ". How can I help you today?");
    },
    instructions: [{
      message: 'Customer to specify their request',
      messageStyle: 'allCaps',
      footnote: 'Customer must explicitly mention they wish to take out a new Pet Insurance Policy.'
    }]
  }, {
    script: function script() {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, "Before we commence I need to let you know this is general advice only and we do not take into account your individual objectives, financial situation or needs while providing this advice. As a result, the advice may not be appropriate for you."), /*#__PURE__*/_react["default"].createElement("p", null, "In this call I will be asking you some questions. Some of these will involve collecting personal information. We collect, store and disclose your personal information in accordance with the privacy policy. This can be found in the Combined Financial Services Guide and Product Disclosure Statement."), /*#__PURE__*/_react["default"].createElement("p", null, "This is available on our website and will be sent to you if you choose to complete the application and it is accepted."));
    }
  }],
  aboutPetPreStart: [{
    script: function script() {
      return 'Can I start with...';
    },
    instructions: [{
      message: 'Confirm and enter the following details with the customer:'
    }]
  }],
  aboutOwnerPreStart: [{
    instructions: [{
      message: 'Confirm and enter the following details with the customer:',
      messageStyle: 'bold'
    }]
  }],
  additionalBenefits: [{
    instructions: [{
      message: 'Additional Benefits when purchasing an Everyday Pet Insurance policy. ',
      messageStyle: 'bold'
    }, {
      message: /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, "Vet Assist \u2013 Get access to VetAssist, a separate subscription service which connects you via video call or online chat consultation with a licensed Australian Vet 24/7.Valued at $199 p.a."), /*#__PURE__*/_react["default"].createElement("li", null, "GapOnly \u2013 access the GapOnly service where you can have your claim assessed while you\u2019re still at the vet (participating vets only). Claim your insurance benefit on the spot and only pay the gap on eligible claims at participating vets (the gap is the difference between the vet\u2019s invoice and the claim benefit under your policy). You can find more information on GapOnly on their website - gaponly.com.au")),
      messageStyle: 'highAccuracy'
    }]
  }]
};
var DefaultStaffInstructionsPetDetails = exports.DefaultStaffInstructionsPetDetails = {
  petSpeciesRadios: {
    groupLabel: function groupLabel(_ref2) {
      var petName = _ref2.petName,
        speciesCode = _ref2.speciesCode;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Is ", petName || 'your pet', " a dog or a cat?", speciesCode === 'FELINE' && /*#__PURE__*/_react["default"].createElement("span", null, "Is ", petName, " an indoor cat?"));
    },
    customCssClass: 'staffHighAccuracy'
  },
  petNameInput: {
    label: function label() {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "What is your pet\u2019s name?");
    },
    customCssClass: 'staffHighAccuracy'
  },
  petBreedInput: {
    label: function label(petName) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "What breed is ", petName || 'your pet', "?");
    },
    customCssClass: 'staffHighAccuracy'
  },
  petBirthdate: {
    label: function label(petName) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "What is ", petName || 'your pet', "\u2019s date of birth?");
    },
    customCssClass: 'staffHighAccuracy'
  },
  petGenderRadios: {
    groupLabel: function groupLabel(petName) {
      return "What is ".concat(petName || 'your pet', "'s gender?'");
    },
    customCssClass: 'staffHighAccuracy'
  },
  petDesexedRadios: {
    groupLabel: function groupLabel(petName) {
      return "Is ".concat(petName || 'your pet', " desexed?'");
    },
    customCssClass: 'staffHighAccuracy'
  },
  addAPetButton: {
    script: function script() {
      return 'Do you have another pet you want to insure?';
    },
    instructions: [{
      message: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, "Confirm with the customer, if they would like to add another pet to the policy. If yes, proceed to the next step."), /*#__PURE__*/_react["default"].createElement("p", null, "If no, then repeat step 3 for each additional pet the customer would like to add."))
    }]
  }
};
var DefaultStaffInstructionsOwnerDetails = exports.DefaultStaffInstructionsOwnerDetails = {
  ownerTitleInput: {
    label: 'What is your preferred title',
    customCssClass: 'staffHighAccuracy'
  },
  ownerBirthdateInput: {
    label: 'What is your date of birth?',
    customCssClass: 'staffHighAccuracy'
  },
  ownerEmailInput: {
    label: 'What is your email address? (If email address is shared, state: Please note that by providing your email address, you agree to receiving communications in relation to this quote.)',
    customCssClass: 'staffHighAccuracy'
  },
  ownerNameInput: {
    label: 'What is your name?',
    customCssClass: 'staffHighAccuracy'
  },
  ownerFirstNameInput: {
    label: 'What is your first name?',
    customCssClass: 'staffHighAccuracy'
  },
  ownerLastNameInput: {
    label: 'What is your last name?',
    customCssClass: 'staffHighAccuracy'
  },
  ownerMobileInput: {
    label: 'What is the best contact number to reach you?',
    customCssClass: 'staffHighAccuracy'
  },
  ownerPostCodeInput: {
    label: 'What is your postcode?',
    customCssClass: 'staffHighAccuracy'
  },
  ownerMembershipRadios: {
    groupLabel: 'Do you have a member number?',
    customCssClass: 'staffHighAccuracy'
  },
  ownerMemberNumberInput: {
    label: 'Please enter the member number'
  },
  ownerPromoCodeInput: {
    label: 'Do you have a promo code?',
    customCssClass: 'staffHighAccuracy'
  },
  ownerAddressAutoCompleteInput: {
    label: 'What is your street address',
    customCssClass: 'staffHighAccuracy'
  },
  ownerEmailCommsRadios: {
    groupLabel: 'Would you like to receive all communication by email?',
    customCssClass: 'staffHighAccuracy'
  },
  ownerMarketingFeedChannel: {
    label: 'How did you hear about us?'
  }
};